export default {"src":"/_next/static/media/logo-rightride-autocanada.cb8ad719.svg","height":50,"width":173,"blurWidth":0,"blurHeight":0};